import React, { lazy } from 'react';
import { motion } from 'framer-motion';
export function SolutionIntro() {
  return <section className="py-24 bg-navy-900 relative overflow-hidden" data-id="element-177">
      <div className="absolute inset-0 bg-stadium-glow opacity-50 pointer-events-none" data-id="element-178"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-179">
        <div className="max-w-4xl mx-auto text-center" data-id="element-180">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} data-id="element-181">
            <h2 className="font-anton text-4xl md:text-6xl text-gold-500 uppercase tracking-wide mb-4" data-id="element-182">
              THE SOLUTION YOU'VE BEEN WAITING FOR
            </h2>
            <h3 className="font-oswald text-2xl md:text-3xl text-white uppercase tracking-widest mb-12" data-id="element-183">
              A COMPLETE 6-VOLUME COACHING SYSTEM
            </h3>
            <p className="text-xl text-gray-300 font-medium mb-12" data-id="element-184">
              Designed specifically for football coaches.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="mb-16 relative" data-id="element-185">
            <div className="absolute -inset-4 bg-gold-500/10 blur-2xl rounded-full" data-id="element-186"></div>
            <img src="https://cdn.magicpatterns.com/uploads/qJHa7epYciq8VTrPkY2Abk/ChatGPT_Image_11_jun_2026,_14_59_45.webp" alt="Football Ready System 365 — 6 powerful volumes, one complete system" loading="lazy" decoding="async" className="relative w-full max-w-3xl mx-auto h-auto rounded-xl shadow-2xl border border-navy-700/50" data-id="element-187" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="prose prose-lg prose-invert mx-auto text-gray-300" data-id="element-188">
            <p className="text-xl md:text-2xl font-medium text-white mb-6" data-id="element-189">
              FOOTBALL READY: SYSTEM 365 is much more than a coaching manual.
            </p>
            <p className="mb-8 leading-relaxed" data-id="element-190">
              It is a complete coaching operating system that gives you
              structured player development, ready-to-use sessions, tactical
              progression, season planning tools, evaluation systems, and coach
              management resources.
            </p>
            <div className="flex flex-col md:flex-row justify-center gap-4 md:gap-8 font-oswald text-xl text-gold-400 uppercase tracking-wider" data-id="element-191">
              <span data-id="element-192">✓ Everything organized.</span>
              <span data-id="element-193">✓ Everything structured.</span>
              <span data-id="element-194">✓ Everything ready to use.</span>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}